exports.supportedLanguages = {
  en: 'English',
  'pt-br': 'Português do Brasil',
};